import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const PartnerModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default PartnerModule;